/**
 * Where the API is served. Kept free of imports: the API clients load it while
 * the store/helper modules that import them are still initialising.
 */

/** Port of the local API in dev (`VITE_API_PORT`, else the historical defaults). */
export function devApiPort(): string | number {
  if (import.meta.env.VITE_API_PORT) {
    return import.meta.env.VITE_API_PORT
  }

  return window.location.port === '1600' ? 2005 : 8102
}

/**
 * Request paths carry their own `/api/` prefix, as the Wayfinder helpers
 * (`src/wayfinder`) generate them. Always an absolute origin, so a path
 * missing its leading slash fails the same way in dev and in production
 * instead of resolving against the current page there.
 */
export const apiOrigin =
  process.env.NODE_ENV === 'development'
    ? `http://${window.location.hostname}:${devApiPort()}`
    : window.location.origin

/**
 * Base of the API paths, for the few places that still build URLs by hand.
 * Prefer the Wayfinder helpers.
 */
export const baseURL = `${apiOrigin}/api/`
